import {
  GET_AUTH_SUMMARY_FAILURE,
  GET_AUTH_LIST_CLIENT_POLICIES_BY_CLIENT_FAILURE,
  GET_AUTHORIZATION_COMMENTS_FAILURE,
  GET_FILE_TASKS_FAILURE
} from 'modules/authorizations/store/types/authorizationTypes';
import { GET_CANDIDATE_SERVICES_FAILURE } from 'modules/authorizations/store/types/canidateTripTypes';
import {
  GET_ALL_BROKER_AGENTS_FAILURE,
  GET_EXPENSE_CODES_BY_CLIENT_ID_FAILURE,
  GET_INSPECTORS_FAILURE,
  GET_TITLE_REP_FAILURE,
  GET_VENDOR_CONTACT_FAILURE,
  GET_VENDOR_DETAILS_FAILURE,
  GET_VENDORS_FAILURE
} from 'modules/authorizations/store/types/dataManagementTypes';
import { GET_AUTH_OFFER_HISTORY_LIST_FAILURE } from 'modules/authorizations/store/types/destinationServiceTypes';
import { GET_GLOBAL_INFO_FAILURE } from 'modules/authorizations/store/types/globalTypes';
import { GET_HOMESALE_INFO_FAILURE } from 'modules/authorizations/store/types/homesaleTypes';
import { GET_HHG_SEGMENTS_FAILURE } from 'modules/authorizations/store/types/houseHoldGoodsTypes';
import { GET_EXPENSE_LINES_BY_AUTH_FAILURE, GET_EXPENSE_SUMMARIES_BY_AUTH_FAILURE } from 'modules/expenses/store/types';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { GET_AUTH_TAX_ASSISTANCE_FAILURE, GET_TAX_POLICIES_BY_CLIENT_FAILURE } from '../store/types/taxAssistanceTypes';
import { GET_ATTACHMENT_FAILURE } from '../store/types/attachmentTypes';
import { GET_TEMPORARY_LIVING_ASSIGNMENT_FAILURE } from '../store/types/temporaryLivingTypes';
import {
  GET_ALL_COUNTRIES_FAILURE,
  GET_ALL_CURRENCIES_FAILURE,
  GET_ALL_ENUMERATIONS_FAILURE,
  GET_ALL_PROVINCES_FAILURE,
  GET_ALL_SALE_TYPES_FAILURE,
  GET_ALL_WEIGHT_TYPES_FAILURE
} from 'modules/enumerations/store/enumeationTypes';

export const fetchBrokerAgents = async (brokerAgents, props) => {
  // if (!brokerAgents || brokerAgents.length === 0) {  // always fetch fresh
  try {
    const brokerAgentsResp = await props.getBrokerAgents();
    if (brokerAgentsResp && brokerAgentsResp.type === GET_ALL_BROKER_AGENTS_FAILURE) {
      props.showToast('Failed to retrieve broker agents info, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return null;
    }
    return brokerAgentsResp;
  } catch (error) {
    console.error('Error fetching broker agents:', error);
    props.showToast('An error occurred while retrieving broker agents.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    throw error;
  }
  // }
  // return brokerAgents;
};

export const fetchInspectors = async (inspectors, props) => {
  // if (!inspectors || inspectors.length === 0) {  // always fetch fresh
  try {
    const inspectorsResp = await props.getInspectors();
    if (inspectorsResp && inspectorsResp.type === GET_INSPECTORS_FAILURE) {
      props.showToast('Failed to retrieve inspectors info, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return null;
    }
    return inspectorsResp;
  } catch (error) {
    console.error('Error fetching inspectors:', error);
    props.showToast('An error occurred while retrieving inspectors.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    throw error;
  }
  // }
  // return inspectors;
};

export const fetchVendors = async (vendors, props) => {
  // if (!vendors || vendors.length === 0) {  // always fetch fresh
  try {
    const vendorsResp = await props.getVendors();

    if (vendorsResp && vendorsResp.type === GET_VENDORS_FAILURE) {
      props.showToast('Failed to retrieve vendor info, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return null;
    }
    return vendorsResp;
  } catch (error) {
    console.error('Error fetching vendors:', error);
    props.showToast('An error occurred while retrieving vendors.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    throw error;
  }
  // }
  // return vendors;
};

export const fetchVendorContacts = async (vendorContacts, props) => {
  // if (!vendorContacts || vendorContacts.length === 0) {  // always fetch fresh
  try {
    const vendorContactsResp = await props.getVendorContacts();
    if (vendorContactsResp && vendorContactsResp.type === GET_VENDOR_CONTACT_FAILURE) {
      props.showToast('Failed to retrieve vendor contact info, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return null;
    }
    return vendorContactsResp;
  } catch (error) {
    console.error('Error fetching vendor contacts:', error);
    props.showToast('An error occurred while retrieving vendor contacts.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    throw error;
  }
  // }
  // return vendorContacts;
};

export const fetchExpenseCodes = async (expenseCodes, props, clientId) => {
  if (!clientId) {
    return expenseCodes;
  }
  try {
    const expenseCodesResp = await props.getExpenseCodesByClientId(clientId);
    if (expenseCodesResp.type === GET_EXPENSE_CODES_BY_CLIENT_ID_FAILURE) {
      props.showToast('Failed to retrieve expense codes, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return null;
    }
    return expenseCodesResp;
  } catch (error) {
    console.error('Error fetching expense codes:', error);
    props.showToast('An error occurred while retrieving expense codes.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    throw error;
  }
};

export const fetchTitleReps = async (titleReps, props) => {
  // if (!titleReps || titleReps.length === 0) {  // always fetch fresh
  try {
    const titleRepsResp = await props.getTitleReps();
      if (titleRepsResp.type === GET_TITLE_REP_FAILURE) {
        props.showToast('Failed to retrieve title reps, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        return null;
      }
      return titleRepsResp;
    } catch (error) {
      console.error('Error fetching title reps:', error);
      props.showToast('An error occurred while retrieving title reps.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      throw error;
    }
  // }
  // return titleReps;
};

export const fetchAuthDetails = async (details, id, props) => {
  try {
    // if (!details || !details?.authDetails) {  // always fetch fresh
    const [authSummaryResp] = await Promise.all([props.getAuthorizationSummary(id)]);

      if (authSummaryResp.type === GET_AUTH_SUMMARY_FAILURE) {
        props.showToast('Failed to retrieve authorization info, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        return null;
      } else {
        if (
          authSummaryResp.response &&
          authSummaryResp.response.authorizationDetails &&
          !props.clientsInfo[authSummaryResp.response.authorizationDetails.clientId]
        ) {
          props.setClientId(authSummaryResp.response.authorizationDetails.clientId);
          await props.getClientDetails(authSummaryResp.response.authorizationDetails.clientId);
        }
        if (authSummaryResp.response && authSummaryResp.response.bankAccounts && Array.isArray(authSummaryResp.response.bankAccounts)) {
          let failure = authSummaryResp.response.bankAccounts.find(bank => bank.errorSyncingToAcumatica === true);
          if (failure) {
            props.showToast('Failed to fetch banking information to Acumatica. Please contact support.', {
              severity: TOAST_MESSAGE_SEVERITY_ERROR
            });
          }
        }
        return authSummaryResp.response;
      }
    // }
    // return null;
  } catch (error) {
    console.error('Error fetching authorization details:', error);
    props.showToast('An unexpected error occurred. Please try again later.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    return null;
  }
};

export const fetchVendordetails = async (details, id, props) => {
  try {
    // if (!details) {  // always fetch fresh
    const [vendorDetailsResp] = await Promise.all([props.getVendorDetails(id)]);

      if (vendorDetailsResp.type === GET_VENDOR_DETAILS_FAILURE) {
        props.showToast('Failed to retrieve vendor info, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        return;
      }
    // }
  } catch (error) {
    console.error('Error fetching vendor details:', error);
    props.showToast('An unexpected error occurred. Please try again later.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
  }
};

export const fetchAuthCanidateDetails = async (details, id, props) => {
  try {
    // if (!details || !details?.authCanidateTrips) {  // always fetch fresh
    const [candidateResp] = await Promise.all([
        //props.getCostEstimates(id),
        props.getCandidateServices(id)
        // props.getCandidateTrips(id),
        //props.getTravelBookingRequestsByAuth(id)
      ]);

      // if (costEstimateResp.type === GET_COST_ESTIMATES_FAILURE) {
      //   props.showToast('Failed to retrieve cost estimates info, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      //   return;
      // }

      if (candidateResp.type === GET_CANDIDATE_SERVICES_FAILURE) {
        props.showToast('Failed to retrieve candidate services, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        return;
      }

      // if (candidateTripsResp.type === GET_ALL_CANDIDATE_TRIPS_FAILURE) {
      //   props.showToast('Failed to retrieve candidate trips, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      //   return;
      // }

      // if (travelRequestsResp.type === GET_TRAVEL_BOOKING_REQUESTS_BY_AUTH_FAILURE) {
      //   props.showToast('Failed to retrieve travel booking requests, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      //   return;
      // }
    // }
  } catch (error) {
    console.error('Error fetching canidate details:', error);
    props.showToast('An unexpected error occurred. Please try again later.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
  }
};

export const fetchAuthDestinationDetails = async (details, id, props) => {
  try {
    // if (!details || !details?.authDestinationService) {  // always fetch fresh
    const [destinationServicesResp] = await Promise.all([props.getAuthDestinationServices(id)]);

      if (destinationServicesResp.type === GET_AUTH_OFFER_HISTORY_LIST_FAILURE) {
        props.showToast('Failed to retrieve all offer history records, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        return;
      }
    // }
  } catch (error) {
    console.error('Error fetching destination details:', error);
    props.showToast('An unexpected error occurred. Please try again later.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
  }
};

export const fetchAuthExpensesDetails = async (details, id, props) => {
  try {
    // if (!details || !details?.authExpenses) {  // always fetch fresh
    const [expenseSummariesResp, expenseLineItemsResp] = await Promise.all([
        props.getExpenseSummariesByAuth(id),
        props.getExpenseLinesByAuthId(id)
      ]);

      if (expenseSummariesResp.type === GET_EXPENSE_SUMMARIES_BY_AUTH_FAILURE) {
        props.showToast('Failed to retrieve submitted expenses, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        return;
      }

      if (expenseLineItemsResp.type === GET_EXPENSE_LINES_BY_AUTH_FAILURE) {
        props.showToast('Failed to retrieve expense line items, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        return;
      }
    // }
  } catch (error) {
    console.error('Error fetching expenses details:', error);
    props.showToast('An unexpected error occurred. Please try again later.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
  }
};

export const fetchAuthGlobalDetails = async (details, id, props) => {
  try {
    // if (!details || !details?.global) {  // always fetch fresh
    const [globalDetailsResp] = await Promise.all([props.getGlobalInfo(id)]);

      if (globalDetailsResp.type === GET_GLOBAL_INFO_FAILURE) {
        props.showToast('Failed to retrieve global service info, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        return;
      }
    // }
  } catch (error) {
    console.error('Error fetching global details:', error);
    props.showToast('An unexpected error occurred. Please try again later.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
  }
};

export const fetchAuthHouseholdGoodsDetails = async (details, id, props) => {
  try {
    // if (!details || !details?.authHouseHoldGoods) {  // always fetch fresh
    const [hhgSegmentsResp] = await Promise.all([props.getHhgSegments(id)]);

      if (hhgSegmentsResp.type === GET_HHG_SEGMENTS_FAILURE) {
        props.showToast('Failed to retrieve hhg segments info, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        return;
      } else {
        return hhgSegmentsResp;
      }
    // }
  } catch (error) {
    console.error('Error fetching household goods details:', error);
    props.showToast('An unexpected error occurred. Please try again later.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
  }
};

export const fetchAuthTempLivingDetails = async (details, id, props) => {
  try {
    // if (!details || !details?.authTemporaryLiving) {  // always fetch fresh
    const [assignResp] = await Promise.all([props.getTemporaryLivingAssignments(id)]);

      if (assignResp.type === GET_TEMPORARY_LIVING_ASSIGNMENT_FAILURE) {
        props.showToast('Failed to retrieve assignments info, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        return;
      } else {
        return assignResp;
      }
    // }
  } catch (error) {
    console.error('Error fetching assignments details:', error);
    props.showToast('An unexpected error occurred. Please try again later.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
  }
};

export const fetchAuthHomesaleDetails = async (details, id, props) => {
  try {
    // if (!details || !details?.homesale) {  // always fetch fresh
    const [homesaleResp] = await Promise.all([props.getHomesaleInfo(id)]);

      if (homesaleResp.type === GET_HOMESALE_INFO_FAILURE) {
        props.showToast('Failed to retrieve homesale info, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        return;
      }
    // }
  } catch (error) {
    console.error('Error fetching homesale details:', error);
    props.showToast('An unexpected error occurred. Please try again later.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
  }
};

export const fetchTaxAssistanceDetails = async (details, clientInfo, id, props) => {
  // if ((!details || !details?.authTaxAssistance) && clientInfo) {  // always fetch fresh
  if (clientInfo) {
    const [taxAssistanceResp, taxPoliciesResp] = await Promise.all([
      props.getAuthTaxAssistance(id),
      props.getTaxPoliciesByClientId(clientInfo?.id)
    ]);

    if (taxAssistanceResp.type === GET_AUTH_TAX_ASSISTANCE_FAILURE) {
      props.showToast('Failed to retrieve tax policies, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return;
    }

    if (taxPoliciesResp.type === GET_TAX_POLICIES_BY_CLIENT_FAILURE) {
      props.showToast('Failed to retrieve client tax policies, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return;
    }
  }
};

export const fetchCommentsAndNotes = async (details, id, props) => {
  try {
    // if (!details || !details?.commentsAndNotes) {  // always fetch fresh
    const [commentsAndNotesResp] = await Promise.all([props.getAuthorizationComments(id)]);

      if (commentsAndNotesResp.type === GET_AUTHORIZATION_COMMENTS_FAILURE) {
        props.showToast('Failed to retrieve authorization comments and notes, please try again', {
          severity: TOAST_MESSAGE_SEVERITY_ERROR
        });
        return;
      }
    // }
  } catch (error) {
    console.error('Error fetching authorization comments and notes:', error);
    props.showToast('An unexpected error occurred. Please try again later.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
  }
};

export const fetchFileTasks = async (details, id, props) => {
  try {
    // if (!details || !details?.fileTasks) {  // always fetch fresh
    const [fileTasksResp] = await Promise.all([props.getTasksByFileId(id)]);

      if (fileTasksResp.type === GET_FILE_TASKS_FAILURE) {
        props.showToast('Failed to retrieve tasks for this file...', {
          severity: TOAST_MESSAGE_SEVERITY_ERROR
        });
        return;
      }
    // }
  } catch (error) {
    console.error('Error fetching file tasks:', error);
    props.showToast('An unexpected error occurred. Please try again later.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
  }
};

export const fetchAttachment = async (fileId, props) => {
  try {
    const attachmentResp = await props.getAttachment(fileId);
    if (attachmentResp.type === GET_ATTACHMENT_FAILURE) {
      props.showToast('Failed to retrieve attatchment, please try again', {
        severity: TOAST_MESSAGE_SEVERITY_ERROR
      });
      return false;
    }
    return attachmentResp.response;
  } catch (error) {
    console.error('Error fetching attachment:', error);
    props.showToast('An unexpected error occurred. Please try again later.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    return false;
  }
};

export const fetchClientPoliciesByClient = async (policyOptionsList, moveTrackClientId, props) => {
  try {
    // if (!policyOptionsList && moveTrackClientId) {  // always fetch fresh
    if (moveTrackClientId) {
      const [clientPoliciesByClientResp] = await Promise.all([props.getAuthClientPoliciesListByClient(moveTrackClientId)]);

      if (clientPoliciesByClientResp.type === GET_AUTH_LIST_CLIENT_POLICIES_BY_CLIENT_FAILURE) {
        props.showToast('Failed to retrieve client policies by client info, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        return;
      }
    }
  } catch (error) {
    console.error('Error fetching authorization details:', error);
    props.showToast('An unexpected error occurred. Please try again later.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
  }
};

export const fetchEnumerations = async props => {
  try {
    if (props.enumerations.isLoaded === false || (props.enumerations.allEnums && !props.enumerations.allEnums.countries)) {
      const allEnumsResp = await props.getAllEnumerations();

      const [saleTypesResp, weightTypesResp, provincesResp, currenciesResp, countriesResp] = await Promise.all([
        props.getAllSaleTypes(),
        props.getAllWeightTypes(),
        props.getAllProvinces(),
        props.getAllCurrencies(),
        props.getAllCountries()
      ]);

      if (
        allEnumsResp.type === GET_ALL_ENUMERATIONS_FAILURE ||
        saleTypesResp.type === GET_ALL_SALE_TYPES_FAILURE ||
        weightTypesResp.type === GET_ALL_WEIGHT_TYPES_FAILURE ||
        provincesResp.type === GET_ALL_PROVINCES_FAILURE ||
        currenciesResp.type === GET_ALL_CURRENCIES_FAILURE ||
        countriesResp.type === GET_ALL_COUNTRIES_FAILURE
      ) {
        props.showToast('Failed retrieve enumerations, please try again later', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      }
    }
  } catch (error) {
    console.error('Error fetching enumerations:', error);
    // props.showToast('An unexpected error occurred. Please try again later.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    // Not showing toast here because it seems to be a false flag, preview toast error indicates actual enum failure
  }
};
